export const GAME_STATE_IMPORTED_EVENT = 'gamestate-imported';
